export const enExtra = {
    membership_feat_basic_analysis: 'Basic Analysis',
    membership_feat_daily_plant: 'Daily Plant',
    membership_feat_ai_chat: 'AI Companion',
    membership_feat_advanced_analysis: 'Deep Growth Tracking',
    membership_feat_ai_memory: 'AI Companion',
    membership_feat_daily_report: 'Personalized Diary',
    membership_feat_weekly_report: 'AI Smart Star Bottle Linking',
    membership_feat_monthly_report: 'Step-by-Step To-do Completion',
    membership_feat_yearly_report: 'Deep Growth Tracking',
    membership_feat_mood_ai: 'AI Mood Detection',
    membership_feat_star_bottle_ai: 'AI Goal & Habit Tracking',
    // ── Timeline / DatePicker / EventCard (v1.2) ──
    date_picker_title: 'Select Date',
    month_grid_title: 'Select Month',
    mood_convert_btn: 'Convert',
    mood_return_event: 'Return to Event',
    mood_to_event: 'Convert to Event',
    event_to_mood: 'Convert to Mood',
    image_upload: 'Upload Image',
    chat_input_error_need_text: 'Please add a description to record this',
    image_uploading: 'Uploading...',
    image_upload_fail: 'Upload failed, tap to retry',
    image_delete: 'Delete Image',
    yesterday_popup: 'Last event yesterday',
    event_ongoing: 'Ongoing...',
    end_event_btn: 'End',
    image_crop_title: 'Crop Image',
    image_crop_hint: 'Drag to reposition',
    image_recrop: 'Re-crop',
    // ── Yesterday Review (New Day) ──
    yesterday_summary: 'You logged {{count}} entries yesterday',
    previous_day_summary: 'On {{date}}, you logged {{count}} entries',
    yesterday_last_activity: 'Last activity: {{content}}',
    yesterday_tap_to_view: 'Tap to view that day\'s entries',
    new_day_start: 'Start your day with a new record',
    record_what_you_do: "Record what you're doing",
    // ── Night Reminder ──
    night_reminder_title: "Today isn't complete yet",
    night_reminder_body: "Your plant and diary haven't been generated. Take a moment tonight to capture your day~",
    night_reminder_go: 'Generate now',
    night_reminder_dismiss: 'Maybe later',
    // ── Proactive reminder system ──
    reminder_popup_confirm: 'Confirm',
    reminder_popup_deny: "I'm doing something else",
    reminder_popup_or_tell_me: 'Or just tell me',
    reminder_popup_input_placeholder: 'Write something...',
    reminder_activity_wake: 'Woke up',
    reminder_activity_meal_breakfast: 'Having breakfast',
    reminder_activity_meal_lunch: 'Having lunch',
    reminder_activity_meal_dinner: 'Having dinner',
    reminder_activity_work_start: 'Started work',
    reminder_activity_lunch_start: 'Lunch break',
    reminder_activity_lunch_end: 'Back to work',
    reminder_activity_work_end: 'Finished work',
    reminder_activity_sleep: 'Going to sleep',
    reminder_activity_class_morning_start: 'Morning class started',
    reminder_activity_class_morning_end: 'Morning class ended',
    reminder_activity_class_afternoon_start: 'Afternoon class started',
    reminder_activity_class_afternoon_end: 'Afternoon class ended',
    reminder_activity_class_evening_start: 'Evening study started',
    reminder_activity_class_evening_end: 'Evening study ended',
    reminder_hint_start: 'Doing {{activity}} right now? Long-press to start the timer.',
    reminder_hint_eat_start: 'Eating {{activity}} right now? Long-press to start the timer.',
    reminder_hint_end: 'Wrapping up {{activity}}? Long-press to stop the timer.',
    reminder_hint_noun_work: 'work',
    reminder_hint_noun_lunch: 'lunch',
    reminder_hint_noun_dinner: 'dinner',
    reminder_hint_noun_study: 'studying',
    reminder_hint_noun_rest: 'rest',
    evening_check_event_count: 'You logged {{count}} events today',
    evening_check_grow_plant: "Generate today's plant",
    evening_check_view_report: "View today's diary",
    evening_check_snooze: 'Remind me later',
    quick_activity_picker_title: "What are you doing now?",
    quick_activity_meal: 'Eating',
    quick_activity_rest: 'Resting',
    quick_activity_entertainment: 'Entertainment',
    quick_activity_health: 'Exercise',
    quick_activity_social: 'Social',
    quick_activity_other: 'Other',
    quick_activity_input_placeholder: 'Or just tell me...',
    quick_activity_prefix_ended: 'You finished {{activity}}, ',
    onboarding_step1_title: 'Nice to meet you',
    onboarding_step1_desc: 'Seeday will check in at key moments to help you track your day with ease.',
    onboarding_step1_cta: 'Get started',
    onboarding_step2_title: 'Enable reminders',
    onboarding_step2_desc: 'Seeday will gently remind you around work hours and mealtimes to help you log your day automatically.',
    onboarding_step2_allow: 'Allow notifications',
    onboarding_step2_skip: 'Maybe later',
    onboarding_step3_title: 'My schedule',
    onboarding_step3_desc: 'Tell Seeday about your regular schedule so it can remind you at the right moments.',
    onboarding_step4_title: 'My routine',
    onboarding_step4_desc: "Enter your rough daily routine. You can always update it in your profile.",
    onboarding_step5_title: 'All set',
    onboarding_step5_desc: 'Your reminders are configured. Seeday will check in with you at key moments each day.',
    onboarding_step5_cta: 'Start using Seeday',
    onboarding_save_error: 'Network error, please try again',
    onboarding_next: 'Next',
    onboarding_back: 'Back',
    onboarding_skip: 'Skip',
    // ── Onboarding v2 ──
    onboarding2_language_title: 'Choose the language you feel at home in',
    onboarding2_language_desc: 'We will use this language for onboarding and app content. You can change it anytime in Settings.',
    onboarding2_auth_title: 'Welcome to Seeday',
    onboarding2_auth_desc: 'Let us hold your everyday moments with a little more care.',
    onboarding2_auth_placeholder: 'Email',
    onboarding2_auth_password: 'Password',
    onboarding2_auth_account_placeholder: 'Email address',
    onboarding2_auth_password_placeholder: 'Password (at least 6 characters)',
    onboarding2_auth_agreement: 'By continuing, you agree to our Terms of Service and Privacy Policy.',
    onboarding2_auth_cta: 'Start Now',
    onboarding2_auth_error: 'Incorrect email or password, please try again',
    onboarding2_routine_region: 'Your Region',
    onboarding2_routine_region_placeholder: 'e.g. New York or London',
    onboarding2_routine_title: 'Tune reminders to your real rhythm',
    onboarding2_routine_desc: 'Tell Seeday your rhythm and it\'ll show up at just the right moment.',
    onboarding2_routine_identity_title: 'Your current lifestyle',
    onboarding2_routine_basic_title: 'Core routine',
    onboarding2_routine_saving: 'Saving...',
    onboarding2_routine_cta: 'Save & Continue',
    onboarding_trial_title: 'Welcome to Seeday — 7 days, a complete experience just for you.',
    onboarding_trial_subtitle: 'Exclusive for new users: 7 days of full access, no card required, pauses automatically when it ends.',
    onboarding_trial_feat1_title: 'Daily Journal',
    onboarding_trial_feat1_desc: 'Every day, AI crafts a personalized diary from your activities and mood, capturing your growth',
    onboarding_trial_feat2_title: 'Magic Pen',
    onboarding_trial_feat2_desc: 'Paste any text and AI instantly turns it into activity logs and to-dos',
    onboarding_trial_feat3_title: 'Task Breakdown',
    onboarding_trial_feat3_desc: 'Big goals split into small, actionable steps so progress feels effortless',
    onboarding_trial_feat4_title: 'Mood Recognition',
    onboarding_trial_feat4_desc: 'AI reads your emotions in real time, helping you understand your inner patterns',
    onboarding_trial_feat5_title: 'Goal Tracking',
    onboarding_trial_feat5_desc: 'Set a goal and AI finds the relevant moments in your daily logs, watching your habits take root',
    onboarding_trial_feat6_title: 'Personal Memory',
    onboarding_trial_feat6_desc: 'Every little thing you mention, AI keeps it close — the more you share, the better it knows you',
    onboarding_trial_feat7_title: 'All Greenhouse Companions',
    onboarding_trial_feat7_desc: 'Van, Agnes, Zep & Momo, all unlocked. Find your true kindred spirit.',
    onboarding_trial_cta: 'Start My Experience',
    onboarding_trial_footer: 'No charge after the trial ends. Renewal is always your choice. Switch back to free anytime.',
    onboarding2_ai_title: 'Choose Your AI Companion',
    onboarding2_ai_van_badge: 'Unlocked',
    onboarding2_ai_van_desc: 'A lively companion, full of energy like a morning glory.',
    onboarding2_ai_agnes_badge: 'Pro Only',
    onboarding2_ai_agnes_desc: 'An insightful and elegant companion who finds meaning in everyday moments.',
    onboarding2_ai_cta: 'This is the one',
    onboarding2_journal_title: 'Record your first moment today',
    onboarding2_journal_desc: 'Write a small moment, and add a feeling if you want.',
    onboarding2_journal_placeholder: 'Type anything...',
    onboarding2_journal_mood_placeholder: 'Add a feeling too, for example: I feel lighter now.',
    onboarding2_journal_sync_badge: 'Live Sync',
    onboarding2_journal_syncing: 'Syncing...',
    onboarding2_journal_footer: 'Today\'s words become tomorrow\'s clarity',
    onboarding2_journal_cta: "Send to Today's Timeline",
    onboarding_j3_activity_title: 'Log your first activity',
    onboarding_j3_activity_hint: 'e.g. Running, Lunch, Meeting',
    onboarding_j3_activity_placeholder: 'Type an activity, e.g. Running',
    onboarding_j3_shown_title: 'AI recognised it as an activity',
    onboarding_j3_shown_desc: 'Meet the two buttons on the card',
    onboarding_j3_tip_camera: 'You can also attach a photo to this card',
    onboarding_j3_tip_convert: 'Wrong type? Tap to switch it to a mood',
    onboarding_j3_tip_duration: 'Duration: {{duration}}',
    onboarding_j3_tip_duration_mode: 'Duration: {{duration}} (it ends automatically when you log the next activity, or you can tap End manually)',
    onboarding_j3_tip_duration_prefix: 'Duration: {{duration}} (timer stops automatically when you log the next activity, or tap',
    onboarding_j3_tip_duration_suffix: 'to end manually)',
    onboarding_j3_tip_end_manual: 'Tap End when you finish this activity',
    onboarding_j3_tip_end_auto: 'If you start the next activity, this one ends automatically and time is saved',
    onboarding_j3_tip_end_both: 'You can tap End, or just start the next activity and we will end this one automatically',
    onboarding_j3_tip_camera_story: 'Add a photo to remember this moment',
    onboarding_j3_tip_camera_crop: 'Choose the part shown on the card; tapping still opens the full photo',
    onboarding_j3_tip_convert_intent: 'Skip the timer? Tap to switch to a mood card — for feelings, ideas, or fleeting thoughts.',
    onboarding_j3_tip_mood_tag: 'This mood tag records how you felt during this activity, and you can also customize it',
    onboarding_j3_tip_mood_mode: 'Mood mode does not run a timer. Use it for feelings, ideas, or quick thoughts',
    onboarding_j3_tip_mood_linked: 'This feeling is linked under the activity card',
    onboarding_j3_tip_switch_back_event_continue: 'You are testing now. Tap to switch back to an activity to continue',
    onboarding_j3_tip_switch_back_mood_continue: 'You are testing now. Tap to switch back to a mood to continue',
    onboarding_j3_tip_mood_return: 'Move this mood back under your latest activity',
    onboarding_j3_tip_mood_to_event: 'Turn this mood into an activity and start timing',
    onboarding_j3_tip_mood_detach_prefix: 'Tap the',
    onboarding_j3_tip_mood_detach_suffix: 'button next to the mood to split it into a standalone mood card',
    onboarding_j3_delete_blocked: 'This onboarding sample record cannot be deleted in this step',
    onboarding_j3_tip_cta: 'Got it, continue',
    onboarding_j3_mood_title: 'Now log how you feel',
    onboarding_j3_mood_hint: 'e.g. Happy, Tired, Focused',
    onboarding_j3_mood_placeholder: 'Type a feeling, e.g. Happy',
    onboarding_j3_mood_skip: 'Skip',
    onboarding_j3_complete_title: 'Keep exploring',
    onboarding_j3_complete_desc: 'Try out the different card actions',
    onboarding_j3_start_btn: 'Start using Seeday',
    onboarding_j3_magic_pen_teaser_title: 'Give Magic Pen a try!',
    onboarding_j3_magic_pen_teaser_desc: 'Type a line of text and AI turns it into activity logs and to-dos',
    onboarding_j3_send: 'Send',
    onboarding2_todo_title: 'Set one doable intention for today',
    onboarding2_todo_add_placeholder: 'Add a to-do item...',
    onboarding2_todo_cta: 'Next',
    onboarding2_todo_hint: 'Add at least one to-do before moving on',
    onboarding_timepicker_cancel: 'Cancel',
    onboarding_timepicker_confirm: 'Done',
    onboarding2_sub_title: 'Go Pro',
    onboarding2_sub_feature_agnes: 'Unlock Agnes AI companion',
    onboarding2_sub_feature_records: 'Unlimited records & daily analysis',
    onboarding2_sub_feature_insights: 'Advanced emotional insights',
    onboarding2_sub_feature_support: 'Priority support',
    onboarding2_sub_trial: 'Start 7-Day Free Trial',
    onboarding2_sub_skip: 'Maybe later',
    onboarding2_sub_monthly_label: 'Monthly',
    onboarding2_sub_yearly_label: 'Annual (Best value)',
    onboarding2_sub_monthly_price: '$3.99/mo',
    onboarding2_sub_yearly_price: '$29.99/yr',
    onboarding2_sub_tagline: 'Data is more than numbers — growth within reach',
    onboarding2_sub_features_title: 'Pro Perks',
    onboarding2_sub_popular_badge: 'Top Pick',
    onboarding2_sub_cta_trial: 'Start 7-Day Free Trial',
    onboarding2_sub_cta_upgrade: 'Upgrade to Pro',
    onboarding2_sub_skip_v2: 'Maybe later',
    onboarding2_sub_badge_cancel: 'Cancel anytime',
    onboarding2_sub_badge_secure: 'Secure payment',
    onboarding2_sub_plan_trial_name: '7-Day Free Trial',
    onboarding2_sub_plan_trial_period_unit: '7 days',
    onboarding2_sub_plan_trial_desc: 'Full Pro access, completely free',
    onboarding2_sub_plan_trial_tag: 'Best start',
    onboarding2_sub_plan_yearly_name: 'Annual',
    onboarding2_sub_plan_yearly_period_unit: 'year',
    onboarding2_sub_plan_yearly_desc: 'Limited offer — avg $2.50/mo',
    onboarding2_sub_plan_yearly_tag: 'Save 15%',
    onboarding2_sub_feat_ai_label: 'All AI Characters',
    onboarding2_sub_feat_ai_desc: 'Unlock every AI companion personality',
    onboarding2_sub_feat_growth_label: 'Deep Growth Analysis',
    onboarding2_sub_feat_growth_desc: 'Track mental and behavioural growth',
    onboarding2_sub_feat_memory_label: 'AI Personal Memory',
    onboarding2_sub_feat_memory_desc: 'Deep resonance and continuous feedback',
    profile_schedule_section_title: 'My Schedule',
    profile_user_profile_has_work_schedule: 'I have fixed work hours',
    profile_user_profile_has_class_schedule: 'I have a class schedule',
    profile_user_profile_work_start: 'Work start',
    profile_user_profile_work_end: 'Work end',
    profile_user_profile_lunch_start: 'Lunch start',
    profile_user_profile_lunch_end: 'Lunch end',
    profile_schedule_dinner_time: 'Dinner',
    profile_schedule_work_fields: 'Work hours',
    profile_schedule_identity_free: 'Free',
    profile_schedule_identity_work: 'Work',
    profile_schedule_identity_class: 'Student',
    profile_schedule_identity_current: 'Current',
    profile_schedule_identity_switch_title: 'Switch Schedule Type',
    profile_schedule_identity_switch_body: 'Switching to "{{name}}" will update your reminder schedule.',
    profile_schedule_class_fields: 'Class hours',
    profile_user_profile_class_morning: 'Morning class',
    profile_user_profile_class_morning_start: 'Morning start',
    profile_user_profile_class_morning_end: 'Morning end',
    profile_user_profile_class_afternoon: 'Afternoon class',
    profile_user_profile_class_afternoon_start: 'Afternoon start',
    profile_user_profile_class_afternoon_end: 'Afternoon end',
    profile_user_profile_class_evening: 'Evening class',
    profile_user_profile_class_evening_start: 'Evening start',
    profile_user_profile_class_evening_end: 'Evening end',
    profile_schedule_class_phase2_hint: 'Schedule import coming soon',
    profile_user_profile_reminder_enable: 'Enable timed reminders',
    profile_user_profile_reminder_permission: 'Notification permission',
    profile_user_profile_reminder_grant_permission: 'Grant notification permission',
    profile_user_profile_reminder_today_count: "Today's reminders",
    // ── Telemetry Center ──
    telemetry_hub_title: 'Telemetry Center',
    telemetry_hub_desc: 'Unified entry for instrumentation dashboards. Choose a business module to inspect detailed metrics, event semantics, and operational decision hints.',
    telemetry_hub_open_dashboard: 'Open Dashboard',
    telemetry_hub_module_user_analytics_title: 'User Analytics',
    telemetry_hub_module_user_analytics_desc: 'New users, DAU, premium conversion, D7 retention, and per-user lookup.',
    telemetry_hub_module_user_analytics_usecase: 'Use this board to monitor growth, track premium conversion, and look up specific users.',
    telemetry_hub_module_ai_annotation_title: 'AI Annotation Reply',
    telemetry_hub_module_ai_annotation_desc: 'Covers low-density scoring, lateral-association sampling, trigger, and condensation telemetry.',
    telemetry_hub_module_ai_annotation_usecase: 'Use this board to calibrate trigger probability and monitor whether lateral association is too weak or too frequent.',
    telemetry_hub_module_live_input_title: 'Live Input + Classifier',
    telemetry_hub_module_live_input_desc: 'Covers classification and correction quality, plus merged plant fallback and diary sticker telemetry.',
    telemetry_hub_module_live_input_usecase: 'Use this board to inspect parser quality, correction loops, and fallback stability across languages.',
    telemetry_hub_module_todo_title: 'Todo Decompose',
    telemetry_hub_module_todo_desc: 'Covers todo step-breakdown quality, parse stability, and user regenerate behavior.',
    telemetry_hub_module_todo_usecase: 'Use this board to decide prompt/model tuning priorities with product-readable metrics and action hints.',
    telemetry_hub_module_profile_title: 'Profile Settings',
    telemetry_hub_module_profile_desc: 'Covers root-direction setting entry, edits, resets, save outcomes, and final saved layouts.',
    telemetry_hub_module_profile_usecase: 'Use this board to judge whether root-direction settings are discoverable, frequently adjusted, and worth further UI investment.',
    telemetry_hub_module_feedback_title: 'User Feedback',
    telemetry_hub_module_feedback_desc: 'View issues, suggestions, and bug reports submitted by users through the feedback form.',
    telemetry_hub_module_feedback_usecase: 'Use this board to understand user pain points, bug frequency, and feature requests to guide product priorities.',
    telemetry_feedback_title: 'User Feedback Dashboard',
    telemetry_feedback_desc: 'Latest 200 feedback submissions, sorted newest first.',
    telemetry_feedback_reading_guide: 'Reading guide: monitor total volume first, then issue-type share. A sudden spike in one type usually indicates a concentrated product problem.',
    telemetry_feedback_total: 'Total Submissions',
    telemetry_feedback_total_hint: 'Total feedback items in the selected window; sustained growth usually means expanding issue exposure.',
    telemetry_feedback_type_hint: 'Count for this issue type; rising share should trigger focused investigation for that journey.',
    telemetry_feedback_list_title: 'Feedback List',
    telemetry_feedback_loading: 'Loading…',
    telemetry_feedback_empty: 'No feedback yet',
    telemetry_common_days: '{{n}}d',
    telemetry_common_unknown: 'unknown',
    telemetry_common_na: 'n/a',
    telemetry_common_yes: 'yes',
    telemetry_common_no: 'no',
    // ── Live Input Telemetry ──
    telemetry_live_title: 'Live Input Telemetry',
    telemetry_live_desc: 'Module dashboard for classification, correction, and plant fallback events from Supabase. Diary sticker operations and AI annotation telemetry are merged from',
    telemetry_live_load_failed: 'Failed to load live input telemetry.',
    telemetry_live_loading: 'Loading telemetry dashboard...',
    telemetry_live_admin_hint: 'Current client metadata does not look like an admin account. If this page returns 403 in production, add your email to',
    telemetry_live_admin_hint_suffix: 'or set an admin role in Supabase Auth metadata.',
    telemetry_live_error_hint: 'This page needs the new Supabase table plus server env vars like',
    telemetry_live_summary_classifications: 'Classifications',
    telemetry_live_summary_corrections: 'Corrections',
    telemetry_live_summary_correction_rate: 'Correction Rate',
    telemetry_live_summary_unique_users: 'Unique Users',
    telemetry_live_summary_plant_assets: 'Plant Assets (L1 Hit)',
    telemetry_live_summary_diary_stickers: 'Diary Sticker Ops',
    telemetry_live_summary_bottle_linked: 'Bottle Auto-links',
    telemetry_live_summary_plant_generate: 'Plant Generation (Success / Failed)',
    telemetry_live_daily_series: 'Daily Series',
    telemetry_live_modules_title: 'Feature Subviews',
    telemetry_live_module_classification: 'Activity/Mood Classification',
    telemetry_live_module_tagging: 'Tagging and Bottle Linking',
    telemetry_live_module_plant: 'Plant Generation',
    telemetry_live_module_mixed: 'Other Mixed Events',
    telemetry_live_breakdown_kind: 'By Result Kind (activity/mood)',
    telemetry_live_breakdown_kind_empty: 'No classification result data in this window.',
    telemetry_live_breakdown_confidence: 'By Confidence',
    telemetry_live_breakdown_confidence_empty: 'No confidence data in this window.',
    telemetry_live_breakdown_internal_kind: 'By Internal Kind',
    telemetry_live_breakdown_internal_kind_empty: 'No classification events in this window.',
    telemetry_live_breakdown_correction_paths: 'Correction Paths',
    telemetry_live_breakdown_correction_paths_empty: 'No correction events in this window.',
    telemetry_live_breakdown_top_reasons: 'Top Reasons',
    telemetry_live_breakdown_top_reasons_empty: 'No reason codes yet.',
    telemetry_live_breakdown_by_language: 'By Language',
    telemetry_live_breakdown_by_language_empty: 'No language distribution yet.',
    telemetry_live_breakdown_plant_fallback: 'Plant Fallback Levels',
    telemetry_live_breakdown_plant_fallback_empty: 'No plant fallback telemetry events yet.',
    telemetry_live_breakdown_plant_generate_actions: 'Plant Generation Actions',
    telemetry_live_breakdown_plant_generate_actions_empty: 'No plant generation telemetry events yet.',
    telemetry_live_breakdown_diary_actions: 'Diary Sticker Actions',
    telemetry_live_breakdown_diary_actions_empty: 'No diary sticker telemetry events yet.',
    telemetry_live_breakdown_bottle_link_source: 'Bottle Link Source',
    telemetry_live_breakdown_bottle_link_source_empty: 'No bottle-link source data in this window.',
    telemetry_live_breakdown_bottle_link_target: 'Bottle Link Target (Bottle ID)',
    telemetry_live_breakdown_bottle_link_target_empty: 'No bottle-link target data in this window.',
    telemetry_live_recent_events: 'Recent Events',
    telemetry_live_recent_empty: 'No recent telemetry events yet.',
    telemetry_live_recent_len: 'len {{n}}',
    telemetry_live_recent_annotation_event: 'annotation_event',
    telemetry_live_recent_score: 'score',
    telemetry_live_recent_diary_sticker_unknown: 'diary_sticker_unknown',
    telemetry_live_recent_all: 'all',
    telemetry_live_recent_fallback: 'fallback',
    telemetry_live_recent_report: 'report',
    telemetry_live_recent_date: 'date',
    telemetry_live_recent_order: 'order',
    telemetry_live_recent_request: 'request',
    telemetry_live_recent_user: 'user',
    telemetry_live_table_day: 'Day',
    telemetry_live_table_classifications: 'Classifications',
    telemetry_live_table_corrections: 'Corrections',
    telemetry_live_table_plant_assets: 'Plant Assets',
    telemetry_live_table_diary_stickers: 'Diary Stickers',
    telemetry_live_table_users: 'Users',
    telemetry_live_hint_classifications: 'Total auto-classification volume. High means active use; low may indicate weak entry exposure or trigger conditions.',
    telemetry_live_hint_corrections: 'Manual correction count. High values mean auto-judgment often conflicts with user intent.',
    telemetry_live_hint_correction_rate: 'Formula: corrections / classifications. When high, inspect correction paths first and tune rules.',
    telemetry_live_hint_unique_users: 'Distinct users with at least one event in this window. Measures coverage, not frequency.',
    telemetry_live_hint_plant_assets: 'Displays "plant asset events / L1 hit rate". Lower L1 means deeper fallback and likely asset/mapping gaps.',
    telemetry_live_hint_diary_stickers: 'Diary sticker operation count. Useful for tracking diary interaction engagement.',
    telemetry_live_hint_bottle_linked: 'Total bottle auto-link count (todo_link/keyword/ai). Used to evaluate the auto-reward hit capability.',
    telemetry_live_hint_plant_generate: 'Shows "success / failed". If failures rise, inspect plant generation pipeline and fallback assets first.',
    telemetry_live_membership_title: 'Membership Classification Paths',
    telemetry_live_membership_desc: 'Aggregates Free/Plus paths from classification reason tags to show AI participation and bottle-match source quality.',
    telemetry_live_membership_user_plan: 'By User Plan',
    telemetry_live_membership_classification_path: 'By Classification Path',
    telemetry_live_membership_ai_called: 'By AI Called',
    telemetry_live_membership_bottle_source: 'By Bottle Match Source',
    telemetry_live_membership_empty: 'No membership classification data in this window.',
    // ── AI Annotation Telemetry ──
    telemetry_ai_title: 'AI Annotation Telemetry',
    telemetry_ai_desc: 'This board tracks low-narrative scoring, lateral-association sampling, event triggering, and downstream condensation.',
    telemetry_ai_load_failed: 'Failed to load AI annotation telemetry dashboard.',
    telemetry_ai_loading: 'Loading AI annotation telemetry...',
    telemetry_ai_decision_hint: 'Decision hint: if lateral trigger rate is persistently above 65%, reduce base probability; if below 35%, raise base probability or increase probability delta.',
    telemetry_ai_summary_trigger_rate: 'Lateral Trigger Rate',
    telemetry_ai_summary_samples: 'Lateral Samples',
    telemetry_ai_summary_event_triggered: 'Event Triggered',
    telemetry_ai_summary_avg_score: 'Avg Narrative Score',
    telemetry_ai_summary_avg_probability: 'Avg Final Probability',
    telemetry_ai_hint_trigger_rate: 'Formula: lateral_triggered / lateral_sampled. If persistently above target, lower trigger probability; if below, raise it.',
    telemetry_ai_hint_samples: 'Total lateral-association sampled count. If sample size is small, avoid over-tuning too early.',
    telemetry_ai_hint_event_triggered: 'Count of final event injections. Read with trigger rate to detect over-triggering or under-triggering.',
    telemetry_ai_hint_avg_score: 'Average low-narrative-density score. Lower scores should generally require stronger narrative support.',
    telemetry_ai_hint_avg_probability: 'Average final trigger probability computed by rules. Use it to compare intended vs actual trigger behavior.',
    telemetry_ai_bucket_title: 'Narrative Score Buckets',
    telemetry_ai_bucket_desc: 'What it means: each bucket groups low-density scores. Lower buckets should generally show higher lateral trigger rate after probability modulation.',
    telemetry_ai_bucket_empty: 'No narrative score buckets yet.',
    telemetry_ai_table_bucket: 'Score Bucket',
    telemetry_ai_table_samples: 'Samples',
    telemetry_ai_table_triggered: 'Triggered',
    telemetry_ai_table_trigger_rate: 'Trigger Rate',
    telemetry_ai_breakdown_event_mix: 'Annotation Event Mix',
    telemetry_ai_breakdown_event_mix_desc: 'What happened in the annotation pipeline and where requests are blocked or converted.',
    telemetry_ai_breakdown_event_mix_empty: 'No annotation telemetry events yet.',
    telemetry_ai_breakdown_by_character: 'By Character',
    telemetry_ai_breakdown_by_character_desc: 'How lateral sampling distributes across companion characters for balancing and QA.',
    telemetry_ai_breakdown_by_character_empty: 'No character-level events yet.',
    telemetry_ai_breakdown_association_types: 'Association Types',
    telemetry_ai_breakdown_association_types_desc: 'Which lateral association dimensions are being sampled in production.',
    telemetry_ai_breakdown_association_types_empty: 'No association type events yet.',
    // ── Todo Decompose Telemetry ──
    telemetry_todo_title: 'Todo Decompose Telemetry',
    telemetry_todo_desc: 'Product-facing quality board for AI todo breakdown. Every metric includes plain-language meaning and optimization hints so PMs can make decisions without reading code.',
    telemetry_todo_load_failed: 'Failed to load todo decompose telemetry dashboard.',
    // ── Profile Settings Telemetry ──
    telemetry_profile_title: 'Profile Settings Telemetry',
    telemetry_profile_desc: 'Behavior board for root-direction settings in Profile. Tracks entry, edits, resets, save outcomes, and the final saved direction layout.',
    telemetry_profile_loading: 'Loading profile settings telemetry...',
    telemetry_profile_load_failed: 'Failed to load profile settings telemetry dashboard.',
    telemetry_profile_reading_guide: 'Reading guide: watch save success rate first, then compare opens vs saves and average changes per save to judge whether users truly use this setting or just explore it once.',
    telemetry_profile_summary_open: 'Opened',
    telemetry_profile_summary_open_hint: 'How many times admins-observed users opened the root-direction panel in this window.',
    telemetry_profile_summary_save_rate: 'Save Success Rate',
    telemetry_profile_summary_save_rate_hint: 'Among explicit save attempts, how often cloud persistence succeeded.',
    telemetry_profile_summary_users: 'Unique Users',
    telemetry_profile_summary_users_hint: 'Distinct users who touched this setting flow at least once.',
    telemetry_profile_summary_savers: 'Users Who Saved',
    telemetry_profile_summary_savers_hint: 'Distinct users who actually confirmed a root-direction layout.',
    telemetry_profile_summary_avg_changes: 'Avg Changes / Save',
    telemetry_profile_summary_avg_changes_hint: 'A rough signal of how much people tweak before committing a final order.',
    telemetry_profile_series_title: 'Daily Series',
    telemetry_profile_series_desc: 'Daily trend of opens, edits, resets, save outcomes, and unique users.',
    telemetry_profile_series_empty: 'No profile settings telemetry yet.',
    telemetry_profile_table_day: 'Day',
    telemetry_profile_table_open: 'Opened',
    telemetry_profile_table_change: 'Changed',
    telemetry_profile_table_reset: 'Reset',
    telemetry_profile_table_save: 'Saved',
    telemetry_profile_table_fail: 'Save Failed',
    telemetry_profile_table_users: 'Users',
    telemetry_profile_breakdown_events: 'Event Mix',
    telemetry_profile_breakdown_events_desc: 'Which actions dominate this setting flow: open, tweak, reset, or save.',
    telemetry_profile_breakdown_events_empty: 'No settings events yet.',
    telemetry_profile_breakdown_slots: 'Changed Slots',
    telemetry_profile_breakdown_slots_desc: 'Which root-direction positions users most often adjust.',
    telemetry_profile_breakdown_slots_empty: 'No slot-change events yet.',
    telemetry_profile_breakdown_orders: 'Saved Orders',
    telemetry_profile_breakdown_orders_desc: 'Which full root-direction layouts users actually keep after saving.',
    telemetry_profile_breakdown_orders_empty: 'No saved orders yet.',
    telemetry_profile_recent_title: 'Recent Events',
    telemetry_profile_recent_desc: 'Latest root-direction interactions for qualitative inspection and QA.',
    telemetry_profile_recent_empty: 'No recent root-direction events yet.',
    telemetry_profile_recent_user: 'user',
    telemetry_profile_recent_slot: 'slot',
    telemetry_profile_recent_from: 'from',
    telemetry_profile_recent_to: 'to',
    telemetry_profile_recent_order: 'order',
    telemetry_todo_loading: 'Loading todo decompose telemetry...',
    telemetry_todo_reading_guide: 'Reading guide: prioritize parse failure rate and empty rate first (quality), then monitor regenerate rate (user friction) for model and prompt tuning.',
    telemetry_todo_metric_label_what: 'What',
    telemetry_todo_metric_label_business: 'Business',
    telemetry_todo_metric_label_action: 'Action',
    telemetry_todo_metric_empty_rate_title: 'Empty Step Rate',
    telemetry_todo_metric_empty_rate_what: 'Among successful decompose responses, how often we got zero usable steps.',
    telemetry_todo_metric_empty_rate_business: 'High value means users click but still cannot start work, so trust drops.',
    telemetry_todo_metric_empty_rate_action: 'If this rises, tighten prompt specificity and verify language/model quality by breakdowns below.',
    telemetry_todo_metric_parse_rate_title: 'Parse Failure Rate',
    telemetry_todo_metric_parse_rate_what: 'How often model output could not be parsed into expected JSON.',
    telemetry_todo_metric_parse_rate_business: 'High value means technical reliability issues and invisible user frustration.',
    telemetry_todo_metric_parse_rate_action: 'If above baseline, lower output complexity, reduce temperature, and compare model variants.',
    telemetry_todo_metric_regenerate_rate_title: 'Regenerate Rate',
    telemetry_todo_metric_regenerate_rate_what: 'How often users re-run decomposition after already getting a first decomposition.',
    telemetry_todo_metric_regenerate_rate_business: 'High value suggests first result quality is not actionable enough.',
    telemetry_todo_metric_regenerate_rate_action: 'Review top languages/models with high regenerate behavior and improve prompt examples.',
    telemetry_todo_metric_requested_title: 'Requested',
    telemetry_todo_metric_requested_what: 'Total clicks on decompose action (first run + regenerate).',
    telemetry_todo_metric_requested_business: 'Shows feature demand and adoption.',
    telemetry_todo_metric_requested_action: 'Use with success/failure rates; growth with bad quality means compounding frustration.',
    telemetry_todo_metric_succeeded_title: 'Succeeded',
    telemetry_todo_metric_succeeded_what: 'Requests that produced at least one usable sub-step.',
    telemetry_todo_metric_succeeded_business: 'Core success volume that can convert to task completion.',
    telemetry_todo_metric_succeeded_action: 'Track after prompt/model changes; should increase while empty/failure rates drop.',
    telemetry_todo_metric_failed_title: 'Failed',
    telemetry_todo_metric_failed_what: 'Request-level failures (network/service/runtime) during decomposition.',
    telemetry_todo_metric_failed_business: 'Represents hard blockers where user cannot continue at all.',
    telemetry_todo_metric_failed_action: 'If this spikes, inspect provider status and API errors before prompt tuning.',
    telemetry_todo_metric_avg_steps_title: 'Avg Steps / Success',
    telemetry_todo_metric_avg_steps_what: 'Average number of steps generated when decomposition succeeds.',
    telemetry_todo_metric_avg_steps_business: 'Too low may be vague; too high may create overload.',
    telemetry_todo_metric_avg_steps_action: 'Target a practical range (usually 3-6) and balance with regenerate rate.',
    telemetry_todo_daily_title: 'Daily Trend',
    telemetry_todo_daily_desc: 'Track quality over time. A healthy trend is: requested stable/increasing, while parse-failed/empty/failed stay flat or decline.',
    telemetry_todo_daily_empty: 'No daily trend data yet.',
    telemetry_todo_breakdown_event_mix: 'Event Mix',
    telemetry_todo_breakdown_event_mix_desc: 'Distribution of todo-decompose event stages; useful for funnel diagnosis.',
    telemetry_todo_breakdown_event_mix_empty: 'No todo-decompose events yet.',
    telemetry_todo_breakdown_by_language: 'By Language',
    telemetry_todo_breakdown_by_language_desc: 'Compare quality behavior across zh/en/it to decide language-specific model strategy.',
    telemetry_todo_breakdown_by_language_empty: 'No language signals yet.',
    telemetry_todo_breakdown_by_model: 'By Model',
    telemetry_todo_breakdown_by_model_desc: 'Observe which model variants are producing more empty/failed/retry behavior.',
    telemetry_todo_breakdown_by_model_empty: 'No model usage signals yet.',
    telemetry_todo_recent_title: 'Recent Todo Decompose Events',
    telemetry_todo_recent_desc: 'Use this for concrete QA examples: find bad cases quickly, then replay with the same language/model settings.',
    telemetry_todo_recent_empty: 'No todo-decompose telemetry events yet.',
    telemetry_todo_recent_regen: 'regen',
    telemetry_todo_recent_steps: 'steps',
    telemetry_todo_recent_todo: 'todo',
    telemetry_todo_table_day: 'Day',
    telemetry_todo_table_requested: 'Requested',
    telemetry_todo_table_succeeded: 'Succeeded',
    telemetry_todo_table_empty: 'Empty',
    telemetry_todo_table_parse_failed: 'Parse Failed',
    telemetry_todo_table_failed: 'Failed',
    telemetry_todo_table_regenerate: 'Regenerate',
    // ── User Analytics Dashboard ──
    ua_title: 'User Analytics',
    ua_desc: 'Monitor user growth, premium conversion, and retention quality, with per-user diagnostics for fast investigation.',
    ua_updated: 'Updated',
    ua_loading: 'Loading...',
    ua_back: '← Back',
    ua_days_7: '7 days',
    ua_days_14: '14 days',
    ua_days_30: '30 days',
    ua_days_60: '60 days',
    ua_total_users: 'Total Users',
    ua_hint_total_users: 'Cumulative registered user base size. Use it to track top-line growth pace.',
    ua_total_premium: 'Total Premium',
    ua_hint_total_premium: 'Cumulative premium users plus conversion rate. Directly reflects value-pricing fit.',
    ua_conversion: 'Conversion',
    ua_active_today: 'Active Today',
    ua_hint_active_today: 'Users active at least once today. Primary signal of day-level product stickiness.',
    ua_new_today: 'New Today',
    ua_hint_new_today: 'New registrations today. If high with low activity, optimize first-day activation.',
    ua_premium_sub: 'Premium {{n}}',
    ua_daily_series: 'Daily Series',
    ua_day: 'Day',
    ua_new_users: 'New Users',
    ua_dau: 'DAU',
    ua_new_premium: 'New Premium',
    ua_active_premium: 'Active Premium',
    ua_retention_title: 'D7 Retention (Weekly Cohort)',
    ua_retention_desc: '% of users who registered in week W and sent a message in week W+1.',
    ua_retention_empty: 'Not enough data yet (need 2+ weeks of users).',
    ua_cohort_week: 'Cohort Week',
    ua_retained_d7: 'Retained D7',
    ua_d7_rate: 'D7 Rate',
    ua_lookup_title: 'User Lookup',
    ua_lookup_placeholder: 'Email or user ID',
    ua_lookup_search: 'Search',
    ua_lookup_not_found: 'No user found for "{{query}}".',
    ua_field_id: 'ID',
    ua_field_email: 'Email',
    ua_field_registered: 'Registered',
    ua_field_premium: 'Premium',
    ua_field_premium_yes: 'Yes ({{plan}})',
    ua_field_premium_no: 'No',
    ua_field_messages: 'Total Messages',
    ua_field_focus: 'Focus Sessions',
    ua_field_streak: 'Login Streak',
    ua_field_last_active: 'Last Active',
    ua_field_never: 'Never',
    ua_field_plan_unknown: 'plan unknown',

    // Help & Support
    // Delete account
    delete_account_label: 'Delete Account',
    delete_account_title: 'Delete Account',
    delete_account_subscription_title: 'Cancel your subscription first',
    delete_account_subscription_body: 'If you have an active Seeday Plus subscription, go to iPhone Settings → Your Name → Subscriptions and cancel it first, or you will continue to be charged.',
    delete_account_grace_note: 'Permanent deletion starts immediately after submission. If any server step fails, deletion stops and you will be asked to retry. A completed deletion cannot be restored.',
    delete_account_warning: 'The following will be permanently deleted:',
    delete_account_item1: 'Your login credentials',
    delete_account_item2: 'All chat history and journal entries',
    delete_account_item3: 'All to-dos, goals, and habits',
    delete_account_item4: 'All reports, statistics, feedback, and telemetry',
    delete_account_item5: 'Images in Storage and all locally cached data',
    delete_account_confirm_label: 'I understand permanent deletion starts immediately and cannot be restored once complete',
    delete_account_button: 'Delete Account Now',
    delete_account_cancel: 'Cancel',
    delete_account_loading: 'Processing…',
    delete_account_error: 'Operation failed. Please try again later.',
    delete_account_success: 'Your account has been deleted.',
    delete_account_restored: 'Welcome back! Your account has been restored.',

    // Feedback
    feedback_sheet_title: 'Send Feedback',
    feedback_intro: 'Please describe your experience in as much detail as possible so we can better understand the issue.',
    feedback_email_label: 'Email address',
    feedback_email_placeholder: 'Your email',
    feedback_subject_label: 'Subject',
    feedback_subject_placeholder: 'Summarize the issue in one line',
    feedback_type_label: 'Issue type',
    feedback_type_placeholder: 'Select one',
    feedback_type_bug: 'Bug report',
    feedback_type_account: 'Account issue',
    feedback_type_subscription: 'Subscription & payment',
    feedback_type_feature: 'Product feedback or feature request',
    feedback_type_data: 'Data & privacy',
    feedback_type_other: 'Other',
    feedback_desc_label: 'Description',
    feedback_desc_placeholder: 'Describe the issue or suggestion in detail…',
    feedback_submit: 'Submit',
    feedback_required: 'Please fill in all required fields',
    feedback_open_mail: 'Your mail client will open. Please review and send.',
    feedback_success_title: 'Feedback sent',
    feedback_success_body: 'Thanks for telling us. We will read it carefully.',
    feedback_success_close: 'Done',

    auth_tos_prefix: 'By registering you agree to our',
    auth_tos_privacy_link: 'Privacy Policy',
    auth_tos_required: 'Please agree to the Privacy Policy to continue',

    help_sheet_title: 'Help & Support',
    help_intro: 'Whatever you need, we\'re here to help.',
    help_sec_start: 'Getting Started',
    help_q1: 'How do I start logging?',
    help_a1: 'Just type naturally in chat, for example: "Had breakfast, feeling good." Seeday will automatically identify activities and moods.',
    help_q2: 'What are AI partners?',
    help_a2: 'AI partners respond to your journal content. Van is the free partner; Agnes, Zep, and Momo require Seeday Plus to unlock.',
    help_sec_chat: 'Chat & Journal',
    help_q3: 'What is Magic Pen?',
    help_a3: 'Magic Pen is a smart input tool that parses structured entries — like "ran 30 min at 8am" — into organized activity records automatically.',
    help_q4: 'Can I edit or delete entries?',
    help_a4: 'Yes. Tap a message card to see the delete option; tap the timeline to edit that activity\'s time and content.',
    help_sec_growth: 'Goals & Habits',
    help_q5: 'What are bottles?',
    help_a5: 'Bottles are tools for building habits and goals. Activity cards automatically link related content to grow stars. Weekly and monthly plant reports for full bottles will be available soon — stay tuned!',
    help_q6: 'Does the app support recurring tasks?',
    help_a6: 'Yes — set daily, weekly, or custom repeat schedules for any to-do.',
    help_sec_report: 'Daily Report',
    help_q7: 'When can I view today\'s plant and diary?',
    help_a7: 'Today\'s plant and diary (AI Observation Diary) can be shown or generated after 20:00. Please check after 8 PM.',
    help_sec_membership: 'Membership',
    help_q8: 'What\'s included in Seeday Plus?',
    help_a8: 'Plus unlocks all 4 AI partners, high-frequency smart annotations (up to 9,999/day), AI long-term memory, and more.',
    help_q9: 'How do I manage or cancel my subscription?',
    help_a9: 'You can find Seeday in App Store (profile icon -> Subscriptions) or iPhone Settings (Your Name -> Subscriptions), then tap Cancel Subscription.',
    help_sec_account: 'Account',
    help_q10: 'How do I delete my account?',
    help_a10: 'Tap "Delete Account" in your profile. Your account and all data will be permanently removed.',
    help_q11: 'How do I add and edit to-dos?',
    help_a11: 'In Today\'s Focus, type text and press Enter to add a to-do. Tap a to-do card to edit urgency, due time, linked bottle, and set daily or weekly repeat.',
    help_q12: 'What do the to-do buttons do?',
    help_a12: 'Tap the Pin button to pin this to-do; tap the center triangle Start button to begin the task; tap the alarm button to start focus. Plus members can also use "Step Completion" to split a task into sub-steps and tap the alarm button to start step-by-step continuous focus mode.',
    help_q13: 'What can I do in a bottle?',
    help_a13: 'Tap a bottle to view check-in data. You can also create to-dos directly from it or delete the bottle.',
    help_contact_label: 'Still have questions?',
    help_contact_desc: 'Need support? Email us at',
    help_contact_reply: '',

    // Privacy Policy
    privacy_sheet_title: 'Privacy Policy',
    ai_consent_settings_label: 'AI Data & Consent',
    ai_consent_settings_title: 'AI Data & Consent',
    ai_consent_version: 'Consent version {{version}}',
    ai_consent_title: 'Choose before using AI features',
    ai_consent_intro: 'Seeday sends data needed for a selected AI feature to third-party AI services only after your explicit consent. You can decline and continue using features that do not require AI.',
    ai_consent_data_title: 'Data that may be sent',
    ai_consent_data_body: 'Journal, chat, or task text you enter, plus context needed by the selected feature, such as moods, activities, history summaries, personalization preferences, and weather. Account passwords and payment details are not sent.',
    ai_consent_providers_title: 'Recipients and purpose',
    ai_consent_providers_body: 'DeepSeek, OpenAI, and Google Gemini process the necessary data according to language and feature to classify input, break down tasks, or generate annotations, diaries, insights, profiles, or plant-diary text.',
    ai_consent_control_title: 'Retention and control',
    ai_consent_control_body: 'Verified training-sharing settings are off and we disable application data storage where available. Providers may still keep limited safety or abuse-monitoring logs under their terms. You can withdraw at any time in Settings; no new AI request will be sent after withdrawal.',
    ai_consent_checkbox: 'I explicitly consent to sending the necessary data described above to DeepSeek, OpenAI, and Google Gemini to provide AI features I choose to use.',
    ai_consent_read_privacy: 'Read the full Privacy Policy',
    ai_consent_agree: 'Agree and Enable AI',
    ai_consent_without_ai: 'Decline and Use Non-AI Features',
    ai_consent_withdraw: 'Withdraw Consent and Disable AI',
    ai_consent_saving: 'Saving…',
    ai_consent_save_error: 'We could not save your choice. To protect your data, AI remains disabled. Please try again.',
    ai_consent_status_label: 'Current status',
    ai_consent_status_granted: 'Consented — AI features available',
    ai_consent_status_off: 'Not consented — AI data sharing is off',
    privacy_updated: 'Last updated: July 31, 2026',
    privacy_intro: 'Seeday ("we," "our," or "us") is committed to protecting your privacy. This policy explains what data we collect, how we use it, and your rights.',
    privacy_s1_title: '1. Information We Collect',
    privacy_s1_body: 'Account data: email address, display name, and profile photo (if provided).\nJournal content: messages, moods, activities, to-dos, and notes you enter.\nUsage data: feature interaction frequency and app performance metrics.\nDevice data: device type, operating system version, and timezone.',
    privacy_s2_title: '2. How We Use Your Information',
    privacy_s2_body: 'We use your information to: deliver and improve the app experience; generate AI companion responses and smart annotations; create your daily reports; process subscriptions via Apple In-App Purchase; and send optional push notification reminders.\n\nWe do not sell your personal data to third parties.',
    privacy_s3_title: '3. AI Processing',
    privacy_s3_body: 'Before any data is first sent to a third-party AI service, we separately explain the recipients, data categories, and purposes and request your explicit consent. Declining does not affect features that do not require AI. You can withdraw at any time under Settings → AI Data & Consent; after withdrawal, new third-party AI requests are blocked.\n\nCurrent providers are DeepSeek (Chinese annotations, input classification, Chinese task breakdown, and Magic Pen parsing), OpenAI (English/Italian annotations, diary and short-insight generation, profile extraction, and plant-diary text), and Google Gemini (English/Italian task breakdown). Only content and context needed for the selected feature are sent.',
    privacy_s4_title: '4. Third-Party Services',
    privacy_s4_body: 'Supabase Free: authentication, database, and file storage. The current plan has no scheduled backups, PITR, or Log Drain; platform-log retention follows Supabase\'s current plan rules.\nApple IAP: iOS subscription billing and subscription status verification — governed by Apple\'s Privacy Policy.\nOpen-Meteo: after you set a region, the corresponding latitude and longitude are used to obtain weather and air-quality information; journal text is not sent to Open-Meteo.\nAI providers: DeepSeek, OpenAI, and Google Gemini. OpenAI requests use store=false, and model-feedback, evaluation/fine-tuning, and input/output sharing are disabled on the account. Gemini GenerateContent log storage is disabled on the paid project; Seeday does not use the Interactions API whose account setting shows a 55-day default. Providers may still keep limited records for safety, abuse monitoring, or legal compliance under applicable terms and actual account settings.',
    privacy_s5_title: '5. Data Retention',
    privacy_s5_body: 'We retain data needed to provide the service while your account is active. After you submit account deletion, the system immediately attempts to remove user-scoped database records, Storage files, feedback, telemetry, and the login account. If any step fails, deletion stops and reports the failure rather than claiming completion, so you can retry or contact us. Third-party safety/abuse logs and infrastructure backups may expire on their own schedules and cannot be guaranteed to disappear at the exact moment the account is deleted.',
    privacy_s6_title: '6. Your Rights',
    privacy_s6_body: 'You may access, export, or delete your data and may withdraw consent for third-party AI data sharing under Settings → AI Data & Consent. Withdrawal does not affect the lawfulness of processing before withdrawal. You may also use in-app account deletion or contact our support email.\n\nIf you are in the European Economic Area, you have additional rights under GDPR, including data portability and the right to lodge a complaint with a supervisory authority.',
    privacy_s7_title: '7. Children\'s Privacy',
    privacy_s7_body: 'Seeday is not intended for users under 13. We do not knowingly collect personal data from children.',
    privacy_s8_title: '8. Changes to This Policy',
    privacy_s8_body: 'We may update this policy and will provide in-app notice of material changes. If a change requires new consent, we will request an explicit choice again before sending the affected data.',
    privacy_s9_title: 'Contact Us',
    privacy_s9_body: 'For privacy-related questions, please contact us at',

    // ── Calendar ──
    cal_month_jan: 'January',
    cal_month_feb: 'February',
    cal_month_mar: 'March',
    cal_month_apr: 'April',
    cal_month_may: 'May',
    cal_month_jun: 'June',
    cal_month_jul: 'July',
    cal_month_aug: 'August',
    cal_month_sep: 'September',
    cal_month_oct: 'October',
    cal_month_nov: 'November',
    cal_month_dec: 'December',
    cal_day_sun: 'S',
    cal_day_mon: 'M',
    cal_day_tue: 'T',
    cal_day_wed: 'W',
    cal_day_thu: 'T',
    cal_day_fri: 'F',
    cal_day_sat: 'S',

    // About
    about_sheet_title: 'About Seeday',
    about_tagline: 'Your AI life journal companion.',
    about_desc: 'Write naturally, let AI uncover the meaning in your day, and build a life you\'re proud of.',
    about_version_label: 'Version',
    about_developer_label: 'Developer',
    about_developer_name: 'Seeday Team',
    about_support_label: 'Contact Support',
    about_privacy_link: 'Privacy Policy',
    about_copyright: '© 2025 Seeday. All rights reserved.',

    // Agreement text split (login/register bottom)
    auth_agreement_prefix: 'Before continuing, you can review our',
    auth_agreement_terms: 'Terms of Service',
    auth_agreement_and: 'and',
    auth_agreement_privacy: 'Privacy Policy',

    // Terms of Service panel
    terms_sheet_title: 'Terms of Service',
    terms_updated: 'Last updated: May 2, 2026',
    terms_intro: 'These Terms of Service are effective from the date you first use Seeday. By continuing to use the app, you accept all of the following terms.',
    terms_s1_title: '1. Parties',
    terms_s1_body: 'This Agreement is entered into between you (the End-User) and the Seeday development team ("we," "us," or "our"). Apple Inc. and its subsidiaries are not parties to this Agreement and bear no responsibility for the Application or its content.',
    terms_s2_title: '2. License Grant',
    terms_s2_body: 'We grant you a personal, non-exclusive, non-transferable license to use the Application on any Apple-branded products that you own or control, subject to the Usage Rules set forth in the Apple Media Services Terms and Conditions.',
    terms_s3_title: '3. Subscriptions and Payment',
    terms_s3_body: 'The Application offers an optional subscription ("Seeday Pro"), processed exclusively through Apple In-App Purchase (IAP). Pricing and duration are as displayed in the App Store. Subscriptions renew automatically; to cancel, manage your subscription in your Apple ID settings. All refund requests must be submitted through Apple.',
    terms_s4_title: '4. Prohibited Conduct',
    terms_s4_body: 'You may not: reverse-engineer, decompile, or otherwise attempt to extract the source code of the Application; use the Application for any unlawful purpose; upload content that is infringing, harassing, or malicious; or interfere with the normal operation of the Application in any way.',
    terms_s5_title: '5. Maintenance and Support',
    terms_s5_body: 'We, as the developer, are solely responsible for providing maintenance and support services for the Application. Apple has no obligation whatsoever to furnish any maintenance or support services with respect to the Application. For support, please contact hello@seedayapp.com.',
    terms_s6_title: '6. Warranty',
    terms_s6_body: 'To the maximum extent permitted by applicable law, the Application is provided "as is" without any express or implied warranty. In the event of any failure of the Application to conform to any applicable warranty, you may notify Apple, and Apple will refund the purchase price for the Application to you. To the maximum extent permitted by applicable law, Apple will have no other warranty obligation with respect to the Application, and any other claims, losses, liabilities, damages, costs, or expenses attributable to any failure to conform to any warranty will be our sole responsibility.',
    terms_s7_title: '7. Product Claims',
    terms_s7_body: 'We, not Apple, are responsible for addressing any claims by you or any third party relating to the Application or your possession and use of it, including: (i) product liability claims; (ii) any claim that the Application fails to conform to any applicable legal or regulatory requirement; and (iii) claims arising under consumer protection, privacy, or similar legislation.',
    terms_s8_title: '8. Intellectual Property',
    terms_s8_body: 'In the event of any third-party claim that the Application or your use of it infringes that third party\'s intellectual property rights, we, not Apple, will be solely responsible for the investigation, defense, settlement, and discharge of any such claim.',
    terms_s9_title: '9. Legal Compliance',
    terms_s9_body: 'By using the Application, you represent and warrant that: (i) you are not located in a region subject to a U.S. Government embargo, or that has been designated by the U.S. Government as a "terrorist supporting" region; and (ii) you are not listed on any U.S. Government list of prohibited or restricted parties.',
    terms_s10_title: '10. Third-Party Terms',
    terms_s10_body: 'When using the Application, you must also comply with applicable third-party terms of service, including the Apple Media Services Terms and Conditions and any applicable wireless data service agreement.',
    terms_s11_title: '11. Apple as Third-Party Beneficiary',
    terms_s11_body: 'You and we acknowledge and agree that Apple Inc. and its subsidiaries are third-party beneficiaries of this Agreement. Upon your acceptance of the terms and conditions of this Agreement, Apple will have the right (and will be deemed to have accepted the right) to enforce this Agreement against you as a third-party beneficiary thereof.',
    terms_s12_title: '12. Developer Contact',
    terms_s12_body: 'Developer: Seeday\nContact: hello@seedayapp.com\n\nFor any questions, complaints, or claims regarding this Agreement, please contact us at the email address above.',
} as const;
